import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9c4cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative min-h-[688px] w-[432px] bg-white rounded-[4px] wide-scroller"
}
const _hoisted_2 = { class: "p-[24px]" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "text-[20px] text-Text/text_high font-gordita-medium" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-times text-[24px] !mr-0" }, null, -1))
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-full mt-[24px]" }, null, -1))
const _hoisted_13 = { key: 0 }

import { IncrediSelect, IncrediNote, IncrediButton, useIncrediDialog } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, ref, watch } from 'vue';
import ActiveDirectoryForm from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectoryForm.vue';
import AzureActiveDirectoryForm from '@/components/common/dialogs/settingsActiveDirectoryDialog/azureActiveDirectoryForm.vue';
import { activeDirectoryForms, formActions } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectoryConst';
import { useI18n } from 'vue-i18n';
import { useNotify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { Auth_Result_ErrorCode, External_Authentication_Type, useCommonDataQuery, useSettingsPageLinuxQuery, useSettingsPageWindowsQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { FeatureFlags } from '@/types/utils';
import { useOsService } from '@/services/OsService/OsService';
import { useActiveDirectoryProvider } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectory.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'activeDirectoryDialog',
  setup(__props) {

const formTypes = [activeDirectoryForms.activeDirectory, activeDirectoryForms.azureActiveDirectory];
const showErrorNote = ref(false);
const errorMessageType = ref(Auth_Result_ErrorCode.GeneralError);
const isActivateIsLoading = ref(false);
const { t } = useI18n();
const { toastMessage } = useNotify();
const initialDataIsSet = ref(false);

useActiveDirectoryProvider();
const dialog = useIncrediDialog();
const coordinatorsService = inject(IKCoordinatorsService);
const osService = useOsService();
const settingsCaller = osService?.isWindows.value ? useSettingsPageWindowsQuery : useSettingsPageLinuxQuery;
const GQL_Settings = settingsCaller(() => ({
  coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
}));

const GQL_CommonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));

const featureFlags = computed<FeatureFlags>(() => (GQL_CommonData?.result?.value?.ibManagerEntities?.featureFlags ? JSON.parse(GQL_CommonData?.result?.value?.ibManagerEntities?.featureFlags) : null));
const authData = computed(() => GQL_Settings?.result?.value?.ibManagerEntities?.settings?.common?.auth);

const showHideNoteAnimation = ref(false);

const setActiveDirectorySelection = () => {
  if (authData?.value?.enabled) {
    if (!!featureFlags?.value?.auth?.ldap && authData?.value?.authenticationType === External_Authentication_Type.Ldap) {
      return activeDirectoryForms.activeDirectory;
    }
    if (!!featureFlags?.value?.auth?.azuread && authData?.value?.authenticationType === External_Authentication_Type.AzureAd) {
      return activeDirectoryForms.azureActiveDirectory;
    }
  }
  return osService?.isWindows.value ? activeDirectoryForms.activeDirectory : activeDirectoryForms.azureActiveDirectory;
};

const showEditNote = computed(() => authData?.value?.enabled);

const formTypeSelection = ref('');
const formTypeSelectionComputed = computed({
  get() {
    return formTypeSelection.value;
  },
  set(newValue) {
    formTypeSelection.value = newValue;
  },
});

const isSelectionMenuDisabled = computed(() => {
  if (!featureFlags?.value?.auth?.ldap || !featureFlags?.value?.auth?.azuread) {
    return true;
  }
  return GQL_Settings?.result?.value?.ibManagerEntities?.settings?.common?.auth?.enabled || false;
});

const closeDialog = async () => {
  dialog?.close('connectActiveDirectoryDialog');
};

const handleCloseDialog = (action: formActions) => {
  const message = action === formActions.deactivate ? t('settings.dialogs.connectActiveDirectory.successToast.deactivate') : t('settings.dialogs.connectActiveDirectory.successToast.activate');
  toastMessage(message, CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  closeDialog();
};

const handleErrorMessage = (errorMsgType: Auth_Result_ErrorCode) => {
  showErrorNote.value = true;
  errorMessageType.value = errorMsgType;
  isActivateIsLoading.value = false;
};

watch(
  [authData, featureFlags],
  () => {
    if (!initialDataIsSet.value && authData?.value && featureFlags?.value) {
      formTypeSelection.value = setActiveDirectorySelection();
      initialDataIsSet.value = true;
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      (_unref(featureFlags) && !!_unref(featureFlags).auth && !!_unref(authData))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.title')), 1),
                _createVNode(_unref(IncrediButton), {
                  size: "small",
                  disabled: isActivateIsLoading.value,
                  design: "ghost-grey",
                  fab: "",
                  class: "w-[32px] -mr-2",
                  onClick: closeDialog
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createVNode(_unref(IncrediNote), {
                class: _normalizeClass([{ showNote: _unref(showEditNote), hideAnimation: showHideNoteAnimation.value, hideNote: !_unref(showEditNote) }, "mt-[12px]"]),
                type: "Information"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.editNote')), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              (showErrorNote.value)
                ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                    key: 0,
                    class: "mt-[12px]",
                    type: "Error"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (errorMessageType.value === _unref(Auth_Result_ErrorCode).CertificateValidationError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.errorNote.certificateFailed.a')), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.errorNote.certificateFailed.b')), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.errorNote.general.a')), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.errorNote.general.b')), 1)
                            ]))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(IncrediSelect), {
                items: formTypes,
                "model-value": _unref(formTypeSelectionComputed),
                disabled: _unref(isSelectionMenuDisabled),
                size: "big",
                label: "Directory Type",
                class: "active-directory-select mt-[16px]",
                "min-width": 332,
                "list-min-width": 384,
                direction: "bottom-sticky-left",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (selection) => {
          showErrorNote.value = false;
          formTypeSelection.value = selection;
        })
              }, null, 8, ["model-value", "disabled"]),
              _hoisted_12
            ]),
            (_unref(formTypeSelectionComputed) === _unref(activeDirectoryForms).activeDirectory)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(ActiveDirectoryForm, {
                    onActivateInProcess: _cache[1] || (_cache[1] = ($event: any) => (isActivateIsLoading.value = true)),
                    onShowError: handleErrorMessage,
                    onOnCloseDialog: handleCloseDialog,
                    onDeactivateInProcess: _cache[2] || (_cache[2] = ($event: any) => (showHideNoteAnimation.value = true))
                  })
                ]))
              : (_openBlock(), _createBlock(AzureActiveDirectoryForm, {
                  key: 1,
                  onActivateInProcess: _cache[3] || (_cache[3] = ($event: any) => (isActivateIsLoading.value = true)),
                  onShowError: handleErrorMessage,
                  onOnCloseDialog: handleCloseDialog,
                  onDeactivateInProcess: _cache[4] || (_cache[4] = ($event: any) => (showHideNoteAnimation.value = true))
                }))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})